import { render } from "./CountyAttorneyDocuments.vue?vue&type=template&id=1545c46e&scoped=true"
import script from "./CountyAttorneyDocuments.vue?vue&type=script&lang=js"
export * from "./CountyAttorneyDocuments.vue?vue&type=script&lang=js"

import "./CountyAttorneyDocuments.vue?vue&type=style&index=0&id=1545c46e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1545c46e"]])

export default __exports__